// Animated three-dot "typing…" indicator matching the room's bubble style.
export default function TypingDots() {
  return (
    <div
      className="inline-flex items-center gap-1 px-3 py-2 rounded-2xl bg-[#F0F0EE] border border-[#E5E5E0]"
      aria-label="يكتب الآن"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="w-1.5 h-1.5 rounded-full bg-[#5A6470]"
          style={{ animation: `lex-typing 1.1s ease-in-out ${i * 0.15}s infinite` }}
        />
      ))}
      <style>{`
        @keyframes lex-typing {
          0%,80%,100% { opacity:.3; transform: translateY(0); }
          40%         { opacity:1;  transform: translateY(-3px); }
        }
      `}</style>
    </div>
  );
}
